export const SET_USER = 'SET_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const RESET_USER = 'RESET_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const SET_GLOBAL_VALUE = 'SET_GLOBAL_VALUE';
export const RUN_GLOBAL_FN = 'RUN_GLOBAL_FN';
export const SET_USER_POOL = 'SET_USER_POOL';
export const SET_USER_LOADING = 'SET_USER_LOADING';
export const SET_DEVICE = 'SET_DEVICE';
export const EMIT_EVENT = 'EMIT_EVENT';
export const SET_ORG_LOADING = 'SET_ORG_LOADING';
export const ADD_GLOBAL_ANNOUNCEMENT = 'ADD_GLOBAL_ANNOUNCEMENT';
export const REMOVE_GLOBAL_ANNOUNCEMENT = 'REMOVE_GLOBAL_ANNOUNCEMENT';
export const SET_NETWORK_MODAL = 'SET_NETWORK_MODAL';
